import {
  AUTH_PREFIX_PATH,
  REDIRECT_URL_KEY,
  UNAUTHENTICATED_ENTRY,
  //   UNVERIFIED_ENTRY,
} from "configs/AppConfig";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = () => {
  const { token, userData } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!token) {
    return (
      <Navigate
        to={`${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  } /*else if (token && userData?.status !== "VALIDATED") {
    return <Navigate to={UNVERIFIED_ENTRY} replace />;
  }*/

  return <Outlet />;
};

export default ProtectedRoute;
